/**
 * 注文一覧画面
*/
import React, { useState, useEffect, useRef } from "react";
import jyuService from "../../services/jyu/jyuService";
import IsdSelectBox from "../common/isdselectbox";
import constMap from '../../const/const';
import dialogService from "../../services/common/dialogService";
import { useDispatch } from "react-redux";
import IsdTextboxYmd from "../common/IsdTextboxYmd";
import CustomGrid from "../common/CustomGrid";
import "../../css/jyu/Jyuf105.css";
import asyncService from "../../services/common/asyncService";
import IsdTextboxSuggest from "../common/isdTextboxSuggest";
import myGrid from "../../store/myGridStore";
import stateStore from "../../store/stateStore";
import rootScope from "../../store/rootScopeStore";
import IsdEditable from "../common/isdEditable";
import { observer } from "mobx-react";
import FromToTextBox from "../common/FromToTextBox";
import errMsgService from "../../services/common/errMsgService";
import sessionStore from "../../store/sessionStore";
import { formatDateToText } from "../../util/util";
import pocs from "../../services/pocs";

/**
 * Jyuf105
 * 
 * @param {any} props 
 * @returns 
 */
const Jyuf105 = observer((props) => {
    const [gridData, setGridData] = useState([]);
    const dispatch = useDispatch();

    const initialRef = {
        jykyoKbn: useRef(null),
        jchuymd: useRef(null)
        // kkoKbn: useRef(null)
    }

    // 画面項目を以下のように設定する。
    useEffect(() => {
        stateStore.state = {
            jchuymdFrom: '',
            jchuymdTo: '',
            seizoymdFrom: '',
            seizoymdTo: '',
            shinCd: '',
            shinryksyomei: '',
            jykyoKbn: '',
            // kkoKbn: '',
            // 合計金額
            // jchugokeigaku: '',
            suggestData: []
        }

        // グリッドの列を作成する
        myGrid.props = {
            columnDefs: [
                {
                    Header: '',
                    accessor: 'button',
                    Cell: IsdEditable,
                    editor: {
                        clickFunc: (event, row, cell, name, original) => {
                            const params = rootScope.openerParams;
                            params.dnpyoNo = original.dnpyono;
                            params.updDate = original.upddate;
                        },
                        component: 'button',
                        view: (row, cell, name, original) => {
                            return original[name] === '0' ? '修正' : original[name] === '1' ? '参照' : '';
                        },
                        linkTo: (row, cell, name, original) => {
                            return original[name] === '0' ? '/Jyuf104/2' : original[name] === '1' ? '/Jyuf104/4' : ''
                        }
                    },
                    className: "cell-center",
                    width: 100,
                },
                {
                    Header: '受注日',
                    accessor: 'jchuymd',
                    width: 100,
                },
                {
                    Header: '納品希望日',
                    accessor: 'seizoymd',
                    width: 100,
                },
                {
                    Header: '注文番号',
                    accessor: 'dnpyono',
                    width: 70,
                },
                // {
                //     Header: '合計金額',
                //     accessor: 'jchugokeigaku',
                //     className: "cell-right",
                //     width: 100,
                // },
                {
                    Header: '商品',
                    accessor: 'shinsskimei',
                    width: 180,
                },
                {
                    Header: '数量',
                    accessor: 'jchusryo',
                    className: "cell-right",
                    width: 105,
                },
                {
                    Header: '',
                    accessor: 'tno',
                    width: 60,
                },
                {
                    Header: '状態',
                    accessor: 'jkyo',
                    width: 100,
                }
                // {
                //     Header: '加工',
                //     accessor: 'kko',
                //     width: 100,
                // }
            ]
        }
        rootScope.footer = {
            endBtn: {
                hide: false
            }
        }
        let params = rootScope.openerParams;
        let screenId = params.screenId ? params.screenId : '';
        stateStore.state.suggestData = sessionStore.getSuggestItems('shin');
        if (screenId === 'JYUF104') {
            stateStore.state.jchuymdFrom = !params.jchuymdfrom ? '' : formatDateToText(params.jchuymdfrom, constMap.format.yyyymmdd);
            stateStore.state.jchuymdTo = !params.jchuymdto ? '' : formatDateToText(params.jchuymdto, constMap.format.yyyymmdd);
            stateStore.state.seizoymdFrom = !params.seizoymdfrom ? '' : formatDateToText(params.seizoymdfrom, constMap.format.yyyymmdd);
            stateStore.state.seizoymdTo = !params.seizoymdto ? '' : formatDateToText(params.seizoymdto, constMap.format.yyyymmdd);
            stateStore.state.shincd = !params.shincd ? '' : params.shincd;
            stateStore.state.shinryksyomei = !params.shinryksyomei ? '' : params.shinryksyomei;
            stateStore.state.jykyoKbn = params.jykyokbn;
            // stateStore.state.kkoKbn = params.kkokbn;
        } else {
            let currentDate = new Date();
            let currentDateFormat = formatDateToText(currentDate, constMap.format.yyyymmdd);
            stateStore.state.jchuymdFrom = currentDateFormat;
            stateStore.state.jchuymdTo = currentDateFormat;
            //stateStore.state.seizoymdFrom = currentDateFormat;
            stateStore.state.seizoymdFrom = "";
            //currentDate.setDate(currentDate.getDate() + 1);
            //let nextDate = formatDateToText(currentDate, constMap.format.yyyymmdd);
            //stateStore.state.seizoymdTo = nextDate;
            stateStore.state.seizoymdTo = "";
        }
        initialRef.jchuymd.current.focus();
    }, []);

    // 入力変更の処理
    const handleInputToBlur = event => {
        errMsgService.delMsgKey("jchuymdFromTo");
        if (stateStore.state?.jchuymdFrom && stateStore.state?.jchuymdTo) {
            const fromDate = new Date(stateStore.state?.jchuymdFrom);
            const dateNextMonth = formatDateToText(fromDate.setMonth(fromDate.getMonth() + 1), constMap.format.yyyymmdd);
            if (stateStore.state?.jchuymdTo > dateNextMonth) {
                errMsgService.addMsgKey('EJYU0100', 'jchuymdFromTo');
            }
        }
    };

    // 得意先注文一覧情報取得IFを呼び出して単位情報を注文一覧。
    const search = () => {
        errMsgService.errExistsCheck(() => {
            if ((stateStore.state?.jchuymdFrom && stateStore.state?.jchuymdTo) || (stateStore.state?.seizoymdFrom && stateStore.state?.seizoymdTo) || stateStore.state?.shinCd) {
                let params = {
                    jchuymdfrom: stateStore.state?.jchuymdFrom.replaceAll('/', '-') ? stateStore.state?.jchuymdFrom.replaceAll('/', '-') +' 00:00:00' : '',
                    jchuymdto: stateStore.state?.jchuymdTo.replaceAll('/', '-') ? stateStore.state?.jchuymdTo.replaceAll('/', '-') +' 23:59:59' : '',
                    seizoymdfrom: stateStore.state?.seizoymdFrom.replaceAll('/', '-') ? stateStore.state?.seizoymdFrom.replaceAll('/', '-') +' 00:00:00' : '',
                    seizoymdto: stateStore.state?.seizoymdTo.replaceAll('/', '-') ? stateStore.state?.seizoymdTo.replaceAll('/', '-') +' 23:59:59' : '',
                    shincd: stateStore.state?.shinCd ? stateStore.state?.shinCd : '',
                    jykyokbn: stateStore.state?.jykyoKbn ? stateStore.state?.jykyoKbn : '',
                    shinryksyomei: stateStore.state?.shinryksyomei ? stateStore.state?.shinryksyomei : '',
                }
                rootScope.openerParams = params;

                // 注文一覧情報を取得する。
                dispatch(asyncService.async(jyuService.jyua104(params), (response) => {
                    if (response.data.messageId) {
                        dialogService.okDialog(response.data.messageId, response.data.message);
                    }
                    else {
                        let datas = [];
                        Object.values(response.data).map(item => {
                            let rowDatas = {};
                            rowDatas.dnpyono = item.dnpyono;
                            rowDatas.updkbn = item.updkbn;
                            rowDatas.upddate = item.upddate;
                            rowDatas.jchuymd = item.jchuymd.substring(0, 10).replaceAll('-', '/');
                            rowDatas.seizoymd = item.seizoymd.substring(0, 10).replaceAll('-', '/');
                            rowDatas.shinsskimei = item.shinryksyomei;
                            rowDatas.jchusryo = item.jchusryo;
                            rowDatas.tno = item.tni;
                            // item.jchugokeigaku = Number(item.jchugokeigaku).toLocaleString();
                            // rowDatas.jchugokeigaku = item.jchugokeigaku;
                            rowDatas.jkyo = item.jkyo;
                            rowDatas.kko = item.kko;
                            rowDatas.button = item.updkbn;

                            datas.push(rowDatas);
                        });
                        setGridData(datas);
                    }
                }));
            } else {
                dialogService.okDialog('EJYU0120');
            }
        });
        initialRef.jchuymd.current.focus();
    }

    // 検索条件の絞り込み窓
    const [refineText, setRefineText] = useState('条件を絞り込む');
    const [refineClass, setRefineClass] = useState('');
    const [refine, setRefine] = useState(false);
    const [tableHeight, setTableHeight] = useState(window.innerHeight - 421);
    const [outsideHeight, setOutsideHeight] = useState(285);
    useEffect(() => {
        if (refine) {
            setRefineText('閉じる')
            setRefineClass('open')
            setTableHeight(window.innerHeight - 421);
            setOutsideHeight(421);
        } else {
            setRefineText('条件を絞り込む')
            setRefineClass('')
            setTableHeight(window.innerHeight - 285)
            setOutsideHeight(285);
        }
    }, [refine])



    return (
        <div>
            {/* 登録済かで切り替える */}
            <div>
                <div className="search-area-wrap">
                    <div className={`search-area ${refineClass}`}>
                        <div>
                            <label htmlFor="jchuymdFromTo">注文日</label>
                            <div className="jyuf105-input-display ml50">
                                <FromToTextBox className="jyuf105-input-display" id="jchuymdFromTo" name="jchuymdFromTo" fromValue="jchuymdFrom" toValue="jchuymdTo">
                                    <IsdTextboxYmd className="w105" format="yyyy/MM/dd" name="jchuymdFrom" value={stateStore.state?.jchuymdFrom} onBlur={handleInputToBlur}></IsdTextboxYmd>
                                    <span ref={initialRef.jchuymd} className="ml10">~</span>
                                    <div className="ml10">
                                        <IsdTextboxYmd className="w105" format="yyyy/MM/dd" name="jchuymdTo" value={stateStore.state?.jchuymdTo}
                                            onBlur={handleInputToBlur}></IsdTextboxYmd>
                                    </div>
                                </FromToTextBox>
                            </div>
                        </div>
                        <div className="mt5">
                            <label htmlFor="seizoymdFromTo">納品希望日</label>
                            <div className="jyuf105-input-display ml22">
                                <FromToTextBox className="jyuf105-input-display" id="seizoymdFromTo" name="seizoymdFromTo" fromValue="seizoymdFrom" toValue="seizoymdTo">
                                    <IsdTextboxYmd className="w105" format="yyyy/MM/dd" name="seizoymdFrom" value={stateStore.state?.seizoymdFrom} ></IsdTextboxYmd>
                                    <span className="ml10">~</span>
                                    <div className="ml10">
                                        <IsdTextboxYmd className="w105" format="yyyy/MM/dd" name="seizoymdTo" value={stateStore.state?.seizoymdTo}
                                        ></IsdTextboxYmd>
                                    </div>
                                </FromToTextBox>
                            </div>
                        </div>
                        <div className="mt5">
                            <label>商品名</label>
                            <div className="w105 jyuf105-input-display ml50 product">
                                <IsdTextboxSuggest
                                    id="shinryksyomei" name="shinryksyomei" value={stateStore.state?.shinryksyomei} suggestCd="shinCd"
                                    suggestFields={['shincd', 'shinryksyomei']} labelField="shinryksyomei" data='suggestData' isdmaxlength="20">
                                </IsdTextboxSuggest>
                            </div>
                        </div>
                        <div className="mt5 harf-column">
                            <label>状態</label>
                            <div className="w105 jyuf105-input-display ml64">
                                <IsdSelectBox name="jykyoKbn" id="jykyoKbn" defaultkubunindex="-1" kbnvalue="RNKEIJKYOKBN" value={stateStore.state?.jykyoKbn}
                                    ref={initialRef.jykyoKbn} />
                            </div>
                        </div>
                        {/* <div className="mt5 harf-column">
                            <label>加工依頼</label>
                            <div className="w105 jyuf105-input-display ml35">
                                <IsdSelectBox name="kkoKbn" id="kkoKbn" defaultkubunindex="-1" kbnvalue="KKOKBN"
                                    value={stateStore.state?.kkoKbn} ref={initialRef.kkoKbn} />
                            </div>
                        </div> */}
                    </div>
                    <div className="search">
                        <button className="btn btn-search" onClick={search}>検索</button>
                        <button className={`btn btn-refine ${refineClass}`} onClick={() => { setRefine(!refine) }}>{refineText}</button>
                    </div>
                </div>
                <div id="gridWrapper" className="mt20" style={{ marginTop: '20px' }}>
                    <CustomGrid data={gridData} outsideHeight={outsideHeight} minColumns={1} customItemSize={210} customClass={'Jyuf105'} />
                </div>
            </div>
        </div >
    );
})
export default Jyuf105;